module.exports = __webpack_public_path__ + "img/csr_banner_mobile.b3b5d9de.jpg";